/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages401,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages500,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangsAvailableLanguages.ts";

function getGetApiV1LocationCountriesCountryidLangsAvailableLanguagesUrl(
  countryId: GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams["countryId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/location/countries/${countryId}/langs/available-languages` as const,
  };
  return res;
}

/**
 * @description Retorna as culturas ainda não cadastradas para o país informado. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/available-languages}
 */
export async function getApiV1LocationCountriesCountryidLangsAvailableLanguages(
  countryId: GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams["countryId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages401
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCountriesCountryidLangsAvailableLanguagesUrl(
      countryId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
